<template>
  <div class="room__measures">
    <h3>{{ $t("roomMeasures") }}</h3>

    <div class="flex centered">
      <div class="fancy__input">
        <span class="fancy__input-label fancy__input-item">
          {{
          $t("roomMeasureUnits.height")
          }}
        </span>
        <input
          class="fancy__input-input fancy__input-item"
          type="number"
          name="height"
          id="room_height"
          v-model.number="height"
          @change="handleMeasureChange"
        />
        <span class="fancy__input-unit fancy__input-item">m</span>
      </div>
      <div v-if="heightError" class="height error">{{ $t("roomMeasureUnits.errors.height") }}</div>

      <div class="fancy__input">
        <span class="fancy__input-label fancy__input-item">
          {{
          $t("roomMeasureUnits.length")
          }}
        </span>
        <input
          class="fancy__input-input fancy__input-item"
          type="number"
          name="length"
          id="room_length"
          v-model.number="roomlength"
          @change="handleMeasureChange"
        />
        <span class="fancy__input-unit fancy__input-item">m</span>
      </div>
      <div v-if="lengthError" class="length error">{{ $t("roomMeasureUnits.errors.length") }}</div>

      <div class="fancy__input">
        <span class="fancy__input-label fancy__input-item">
          {{
          $t("roomMeasureUnits.width")
          }}
        </span>
        <input
          class="fancy__input-input fancy__input-item"
          type="number"
          name="width"
          id="room_width"
          v-model.number="width"
          @change="handleMeasureChange"
        />
        <span class="fancy__input-unit fancy__input-item">m</span>
      </div>
      <div v-if="widthError" class="width error">{{ $t("roomMeasureUnits.errors.width") }}</div>
    </div>
  </div>
</template>

<script>
//eslint-disable-next-line
import fancyInput from "@/assets/scss/fancy__input.scss";

export default {
  props: {
    defaultHeight: Number //unused afaik
  },
  methods: {
    //eslint-disable-next-line
    handleMeasureChange(evt) {
      let measureData = {
        height: this.height,
        roomlength: this.roomlength,
        width: this.width
      };
      this.$emit("measurement-change", measureData);
    }
  },
  data() {
    return {
      height: this.height,
      roomlength: this.roomlength,
      width: this.width,
      heightError: false,
      widthError: false,
      lengthError: false
    };
  },
  computed: {
    isMeasureDataComplete() {
      return this.height > 0 && this.roomlength > 0 && this.width > 0;
    }
  },
  watch: {
    height(newHeight, oldHeight) {
      // console.log("watching height: ", oldHeight, newHeight);
      if (newHeight < 0.1) {
        this.heightError = true;
        /*
        if (oldHeight > 0.1) {
          window.setTimeout(() => {
            this.height = oldHeight;
          }, 1000);
        } else {
          // this.height = this.defaultHeight;
        }
        */
      } else {
        this.heightError = false;
      }
    },
    roomlength(newValue, oldValue) {
      // console.log("watching roomlength: ", oldValue, newValue);
      if (newValue < 0.1) {
        this.lengthError = true;
        /*
        if (oldValue > 0.1) {
          window.setTimeout(() => {
            this.roomlength = oldValue;
          }, 1000);
        } else {
          // this.height = this.defaultHeight;
        }
       */
      } else {
        this.lengthError = false;
      }
    },
    width(newValue, oldValue) {
      // console.log("watching width: ", oldValue, newValue);
      if (newValue < 0.1) {
        this.widthError = true;
        /*
        if (oldValue > 0.1) {
          window.setTimeout(() => {
            this.width = oldValue;
          }, 1000);
        } else {
          // this.height = this.defaultHeight;
        }
        */
      } else {
        this.widthError = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/include-media.scss";
@import "@/assets/scss/_variables.scss";
.fancy__input {
  &-unit {
    width: 3ch;
  }
  &-input {
    width: calc(100% - 16ch);
    height: 70%;
  }
  &-label {
    width: 6ch;
  }
}
.flex {
  &.centered {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.error {
  color: red;
  padding: 5px 5px 10px;
}
</style>
